import React from "react";
import ErrorPage from "./index";

export default function Unauthorized() {
  return (
    <ErrorPage
      title="Oh no! It doesn't appear you have permission to view this page."
      errorCode="HTTP ERROR 401"
      infoText="Contact your school administrator if you believe you should be able to access this page."
    />
  );
}
